import { Injectable } from '@angular/core';
import { CookieClientService } from '../utils/cookieClient';
import { HttpClientService } from '../utils/http-client.module';
import { Router } from '@angular/router';
import { APPCONFIG } from '../../app/config';

@Injectable()
export class AuthenticateService {

  config = APPCONFIG;

  constructor(
              private _cookie:CookieClientService,
              private router: Router,
              private _http:HttpClientService
  ) {}

  setAuthorization(authToken : string, isFirstLogin : boolean){
    let currenDate  = new Date();
    currenDate.setTime(currenDate.getTime() + (1000*60*30));
    this._cookie.setValue(btoa('authorization'), authToken, currenDate);
    this.router.navigateByUrl(isFirstLogin ? '/common/restore-password/initPassword':'/app')
  }

  renewAuthorization(){
    this._http.get(this.config.ApiHost + '/renewToken').subscribe(res => {
        let resultBody = JSON.parse(res['_body']);
        if(resultBody['status'] === 'success'){
          let authToken:string = resultBody['body'];
          let currenDate  = new Date();
          currenDate.setTime(currenDate.getTime() + (1000*60*30));
          this._cookie.setValue(btoa('authorization'), authToken, currenDate);
        }else{
          this.router.navigateByUrl('/common/sign-in/expired');
        }
      },
      error => {
        this.router.navigateByUrl('/common/sign-in/expired');
      })
  }

  getUserInfo(){
    return this._http.get(this.config.ApiHost + '/users/myInfo');
  }

}



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/auth/authentication.service.ts